import type { TableFilter } from './TableFilter';

export const createDefaultFilter = (
  filter: TableFilter | undefined | false,
  defaultFilter: TableFilter | undefined,
) => (filter === false ? undefined : (filter ?? defaultFilter));
